import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../../assets/css/modal.css";

const ModalHelper = ({ modalObjectInfo, onClose, fullWidth }) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={fullWidth ? 8 : 5}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90%",
        width: { xs: "90%", sm: "80%" },
        overflow: "auto",
        borderRadius: "2px",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid
          item
          xs={fullWidth ? 0.5 : 1}
          style={{ marginLeft: "15px", marginTop: "-6px !important" }}
        >
          <div className="icon-modal-info" />
        </Grid>
        <Grid item xs={fullWidth ? 11 : 10}>
          <Typography
            className="color-blue-dark"
            sx={{
              fontSize: { xs: "16px", md: "18px" },
              marginTop: "3px",
              marginLeft: "5px",
              fontWeight: 600,
            }}
          >
            {modalObjectInfo.infoTitle}
          </Typography>
        </Grid>
        <Grid
          item
          xs={fullWidth ? 0.5 : 1}
          style={{
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      <Typography
        sx={{
          padding: "10px 15px",
          marginTop: "20px",
          marginBottom: "20px",
          fontSize: { xs: "14px", md: "16px" },
        }}
        className="color-blue-dark"
      >
        {modalObjectInfo.description} <br />
        {modalObjectInfo.descriptionBis}
      </Typography>
    </Grid>
  );
};

export default ModalHelper;
